import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React, { Fragment } from 'react';
import { ReactComponent as Scooter } from '../../../assets/images/scooterBackground.svg';
import { onChangeSbWithErrorsFilter } from '../../../ac/onChangeMapFilters';
import { SbWithErrors } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const SBWithErrorsFilterComponent = ({
    mapFilters,
    onChangeSbWithErrorsFilter,
}) => (
    <div>
        <div className={styles.legHead}>{t`Ошибки на девайсе:`}</div>
        <div className={styles.checkboxIconGrid}>
            {
                SbWithErrors.map(({ value, color, label }) => (
                    <Fragment key={value}>
                        <Scooter
                            style={{
                                width: '16px',
                                height: '16px',
                                verticalAlign: 'middle',
                                marginRight: '4px',
                                color,
                            }}
                        />
                        <label htmlFor={label.id}>{i18n._(label)}</label>
                        <div>
                            <label className={styles.switch}>
                                <input
                                    type='checkbox'
                                    name='poi'
                                    id={value}
                                    checked={mapFilters.sbWithErrorsStatuses.includes(value)}
                                    value={value}
                                    onChange={onChangeSbWithErrorsFilter}
                                />
                                <span className={classnames(styles.sliderRound, styles.slider)} />
                            </label>
                        </div>
                    </Fragment>
                ))
            }
        </div>
        <br></br>
        <small>{t`Чем больше значок девайса, тем дольше длительность ошибки.`}<br></br>{t`Данные обновляются каждые 5 минут.`}</small>
    </div>
);
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, { onChangeSbWithErrorsFilter })(SBWithErrorsFilterComponent);
export const SBWithErrorsFilter = withDisplayedLayersCheck(ConnectedComponent, t`Самокаты с ошибками`);
